export default __webpack_public_path__ + "static/media/placeholder_dummy-2014-store01-mobile-de.911e5c29.png";